import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Message = props => {
  return (
    <div className="c-housing__message">
      <p>
        Huizen in
        {props.searchText && props.searchText !== '' ? (
          <span> {props.searchText}</span>
        ) : null}
      </p>
    </div>
  )
}

export default Message



// WEBPACK FOOTER //
// ./src/js/housing/components/Message.js